<template>
    <div>
        <div>
            <van-dialog v-model="QRCodePopupStatus" width="280px" :showConfirmButton="false" @open="getQRCode">
                <div class="qrcode-popup-content">
                    <div class="title">{{ $t('enterpriseWechatCustomerService') }}</div>

                    <!-- 加载状态 -->
                    <div v-show="loading" class="loading-container">
                        <van-loading type="spinner" color="#1989fa" />
                        <p class="loading-text">{{ $t('generatingQrCode') }}</p>
                    </div>

                    <!-- 二维码容器 -->
                    <div class="qrcode-container" v-show="!loading">
                        <div v-if="qrCodeError" class="error-message">{{ $t('qeCodeGenerationFailed') }}</div>
                        <img v-else class="qrcode-container" ref="qrcode" :src="qrCodeImg" />
                    </div>

                    <div class="text">{{ $t('longPressQRCode') }}</div>
                    <div class="remark" @click="showRemarkPopup">{{ $t('longPressNotRecognized') }}</div>
                </div>
            </van-dialog>
            <img v-if="QRCodePopupStatus" src="../assets/images/fundAccount/closePopup.png" alt="" class="close-popup" @click="showQRCodePopup" />
        </div>
        <RemarkPopup :show.sync="remarkPopupStatus" />
    </div>
</template>

<script>
import RemarkPopup from './RemarkPopup'
import QRCode from 'qrcode'

import { getClientlist } from '@/apis/modules/uc'
import { Loading } from 'vant'

export default {
    name: 'QrCodePopup',
    props: {
        show: Boolean,
    },
    components: {
        RemarkPopup,
        [Loading.name]: Loading,
    },
    computed: {
        QRCodePopupStatus: {
            get() {
                return this.show
            },
            set(val) {
                this.$emit('update:show', val)
            },
        },
    },
    data() {
        return {
            remarkPopupStatus: false,
            qrCodeData: '', // 用于存储从后端获取的二维码数据
            loading: false, // 新增加载状态
            qrCodeError: false, // 新增错误状态
            qrCodeImg: '',
        }
    },
    methods: {
        showQRCodePopup() {
            this.$emit('update:show', false)
        },
        showRemarkPopup() {
            this.remarkPopupStatus = !this.remarkPopupStatus
        },
        generateQRCode(url) {
            this.$nextTick(() => {
                const qrcodeContainer = this.$refs.qrcode
                if (qrcodeContainer) {
                    // 清除之前的二维码
                    this.qrCodeImg = ''
                    try {
                        QRCode.toDataURL(
                            url,
                            {
                                width: 156,
                                color: {
                                    dark: '#000000',
                                    light: '#ffffff',
                                },
                            },
                            (error, url) => {
                                console.log('QRCode.toDataURL ', { error, url })
                                this.qrCodeImg = url
                            }
                        )
                        this.qrCodeError = false
                    } catch (e) {
                        console.error('生成二维码失败:', e)
                        this.qrCodeError = true
                    }
                }
            })
        },
        async getQRCode() {
            this.loading = true
            this.qrCodeError = false

            try {
                const getUserInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
                const cltId = getUserInfo?.clientInfo?.accts?.[0]?.cltId || ''
                const params = {
                    uin: Number(localStorage.getItem('uin')),
                    cltId,
                }
                const { data } = await getClientlist(params)
                const result = data?.result || []
                const qrCode = result.find(item => item.qrCode).qrCode
                if (qrCode) {
                    this.qrCodeData = qrCode
                    this.generateQRCode(this.qrCodeData)
                } else {
                    this.qrCodeError = true
                }
            } catch (e) {
                console.error('Error fetching QR code data:', e)
                this.qrCodeError = true
            } finally {
                this.loading = false // 结束加载
            }
        },
    },
}
</script>

<style scoped lang="less">
.qrcode-popup-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 318px;
    padding-top: 28px;
    padding-bottom: 28px;
    border-radius: 12px;

    .title {
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        letter-spacing: 0%;
        text-align: center;
    }

    /* 加载状态样式 */
    .loading-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 156px;
        height: 184px;

        .loading-text {
            margin-top: 10px;
            color: #666;
            font-size: 12px;
        }
    }

    .qrcode-container {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 156px;
        height: 156px;
        margin: 16px auto;
        margin-bottom: 12px;

        /* 错误信息样式 */
        .error-message {
            padding: 10px;
            color: #f56c6c;
            font-size: 14px;
            text-align: center;
        }
    }

    .text {
        color: #666;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0%;
    }

    .remark {
        margin-top: 16px;
        color: #9c9c9c;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0%;
    }
}

.close-popup {
    position: fixed;
    bottom: 102px;
    left: 50%;
    z-index: 9999;
    width: 24px;
    height: 24px;
    transform: translateX(-50%);
}
</style>
